import { Pipe, PipeTransform } from '@angular/core';
export class SplitcharactersPipe implements PipeTransform {
/**
 * @param {?} value
 * @param {?=} args
 * @return {?}
 */
transform(value: string, args: number = 10): string {
    let /** @type {?} */ res = value;
    if (value && value.length > args && args > 0) {
      const /** @type {?} */ prefix = value.substring(0, args / 2);
      const /** @type {?} */ postfix = value.substring(value.length - args / 2, value.length);
      res = `${prefix}...${postfix}`;
    }
    return res;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'splitcharacters'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SplitcharactersPipe_tsickle_Closure_declarations() {
/** @type {?} */
SplitcharactersPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SplitcharactersPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
